/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from './../box-utils/ParentBox.react.js';

import Error from './system/Error.react.js';
import {sendError} from '../../app/errorDisplayer';
import BoxDecorator from './../box-utils/BoxDecorator.react';
import EmptyContent from './system/EmptyContent.react';
import './FullContact.scss';
import config from '../../../common/config';
import PanelColumns from './system/PanelColumns.react';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

const SHOW_AS_LINES = 2;

const SOCIAL_LIST_SORTER = {
	linkedin: 1,
	facebook: 2,
	twitter: 3,
	googleplus: 4,
	angellist: 5
};

class FullContact extends ParentBox {

    static handlerName = "fullcontact";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "fullcontact";
    }

	getServiceName() {
		return "FullContact";
	}

    showSocial(socialProfiles) {
        if (!socialProfiles || socialProfiles.length === 0) {
            return null;
        }


		let list = socialProfiles
			.filter((profile) => {
				return profile.typeId in SOCIAL_LIST_SORTER;
			})
			.sort((itemA, itemB) => {
				let indexA = SOCIAL_LIST_SORTER[itemA.typeId];
				let indexB = SOCIAL_LIST_SORTER[itemB.typeId];

				return indexA - indexB;
			})
			.map((profile, idx) => {
				let type = profile.typeId;

				if (type === 'googleplus') {
					type = "google-plus";
				}

				return <a href={profile.url} key={idx} target="_blank" title={profile.typeName + (profile.username ? ": " + profile.username : "")}><span className={"fa fa-" + type}></span></a>;
			});

        if (list.length === 0) {
            return null;
        } else {
            return <span className="fullContact-social">{list}</span>;
        }

    }

	getImage(info) {
		if (info.photos && info.photos.length > 0) {
			return (<div className="dativeryValue" style={{backgroundImage: 'url(' + info.photos[0].url + ')'}}></div>);
		}

		if (info.logo) {
			return (<div className="dativeryValue" style={{backgroundImage: 'url(' + info.logo + ')'}}></div>);
		}

		return (<span className="fa fa-user" style={{color: 'grey', fontSize: '22px'}}></span>);
	}

    render() {
        try {
            let {addon} = this.props.viewWithData;

            addon = safeJSONparse(addon);

            let emails = {};
            if (addon && addon['fullcontact']) {
                emails = addon['fullcontact'];
            } else if (this.props.isPreview) {
                /* preview data */
                emails = {
                    "alex.smith@example.com": {
                        "photos": [
                            {
                                "typeName": "Gravatar",
                                "isPrimary": true,
                                "type": "gravatar",
                                "typeId": "gravatar",
								"url": "https:\/\/www.dativery.com\/wp-content\/plugins\/dativery\/title\/profile.png?v=" + config.VERSION
                            }
                        ],
                        "contactInfo": {
                            "familyName": "Smith",
                            "givenName": "Alex",
                            "fullName": "Alex Smith"
                        },
                        "socialProfiles": [
                            {
                                typeName: "Facebook",
                                url: "https://www.facebook.com/dativery"
                            },
                            {
                                typeName: "LinkedIn",
                                url: "https://www.linkedin.com/company-beta/17906114/"
                            }

                        ],
                        "organizations": [
                            {
                                "startDate": "2007",
                                "title": "CEO",
                                "isPrimary": true,
                                "name": "Company, Ltd.",
                                "current": true
                            },
                        ]
                    }
                };
            }

            let totalLength = Object.keys(emails).length;

            if (totalLength === 0) {
                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                        <EmptyContent />
                    </BoxDecorator>
                );
            }

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <PanelColumns>
						{Object.keys(emails).filter((email) => {
							let info = emails[email];

							/* filter out empty (without social profiles) companies */
							if (totalLength > 20 && (!info.socialProfiles || info.socialProfiles.length === 0) && (!info.organisation && (!info.organisations || info.organisations.length <= 1))) {
								return false;
							}

							return true;
						}).map((email, idx) => {
							let info = emails[email];

							if (idx > 10) {
								return null;
							}

							let uniqueCompanies = {};

							return (
								<div className="boxSmall fullContact-item" key={email}>
									<div className="fullContact-image">{this.getImage(info)}</div>
									<div className="fullContact-list">
										<div className="spacer"></div>
										<span className="dativeryValue">
											<small><strong>{info.contactInfo ? info.contactInfo.fullName : (info.organization && info.organization.name ? info.organization.name : email)}</strong></small> {this.showSocial(info.socialProfiles)}
										</span>
											{info.organizations ? <small key="2">{

												info.organizations.filter((org, idx) => {
													let result = org.current && idx < SHOW_AS_LINES && !uniqueCompanies[org.name];
													uniqueCompanies[org.name] = true;

													return result;
												}).map((org, idx) => {
													return (<div className="dativeryValue"
														key={idx}>{" "}<strong>{org.name}</strong>
														{" "}<i>{org.title}</i>
													</div>);
												})
											}{
												info.organizations.filter((org, idx) => {
													let result = org.current && idx > SHOW_AS_LINES && idx < 6 && !uniqueCompanies[org.name];
													uniqueCompanies[org.name] = true;
													return result;
												}).map((org, idx) => {
													return (org.name);
												}).join(', ')
											}</small> : null}
											<div className="spacer"></div>
										</div>
								</div>
							);
						})}
                    </PanelColumns>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(FullContact);
